/**
 * DeleteViewDialog Component
 * Confirmation dialog for deleting a matrix view
 */

import { memo } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { AlertTriangle, X } from 'lucide-react';

const DeleteViewDialog = memo(({
  open,
  onOpenChange,
  viewToDelete,
  onConfirmDelete,
  onCancel
}) => {
  const handleDelete = async () => {
    if (!viewToDelete) return;

    // Call the provided delete function (handles DB + state)
    await onConfirmDelete(viewToDelete.id);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Delete View
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the view "{viewToDelete?.name}"? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
          >
            <X className="h-4 w-4 mr-2" />
            Delete View
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

DeleteViewDialog.displayName = 'DeleteViewDialog';

export default DeleteViewDialog;
